import { render } from "./Notice.vue?vue&type=template&id=ed36fa74&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=ed36fa74&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed36fa74"]])

export default __exports__